import PropTypes from 'prop-types';
import React from 'react';
import FootballPlayer from './FootballPlayer';


export default function FootballTeam(props) {
  return (
    <div className="footballTeamTeam">
      <div className="footballTeamTeamName">
        {props.team.teamName}
        {!!props.team.formation && ` (${props.team.formation})`}
      </div>
      <ul>
        {props.team.players.players.filter(player => player.starter).map(player => (
          <li key={player.id} className="footballTeamPlayerListItem">
            <FootballPlayer player={player}/>
          </li>
        ))}
      </ul>
      <div className="footballTeamTeamName">Substitutes</div>
      <ul>
        {props.team.players.players.filter(player => !player.starter).map(player => (
          <li key={player.id} className="playerListItem">
            <FootballPlayer player={player}/>
          </li>
        ))}
      </ul>
    </div>
  );
}

FootballTeam.propTypes = {
  team: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballTeam.js